import { isTheme, type Theme } from './themes'

export const THEME_COOKIE = 'k2_theme'

const MAX_AGE = 365 * 24 * 60 * 60

export const themeCookie = (value: Theme | null, secure: boolean) =>
  [`${THEME_COOKIE}=${value ?? ''}`, 'Path=/', 'SameSite=Lax', secure ? 'Secure' : '', `Max-Age=${value ? MAX_AGE : 0}`]
    .filter(Boolean)
    .join('; ')

export const themeFromCookie = (header: string | null | undefined): Theme | undefined => {
  const raw = header
    ?.split(';')
    .map(part => part.trim())
    .find(part => part.startsWith(`${THEME_COOKIE}=`))
    ?.slice(THEME_COOKIE.length + 1)

  return isTheme(raw) ? raw : undefined
}

// Empty when nothing is chosen: that is `system`, which theme.css resolves from the OS.
export const themeClass = (theme: Theme | undefined) => theme ?? ''
